import { render, staticRenderFns } from "./Headaches.vue?vue&type=template&id=4cbefaca&scoped=true&"
import script from "./Headaches.vue?vue&type=script&lang=js&"
export * from "./Headaches.vue?vue&type=script&lang=js&"
import style0 from "./Headaches.vue?vue&type=style&index=0&id=4cbefaca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbefaca",
  null
  
)

export default component.exports